var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-header",
    { staticClass: "header-outer-wrapper" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { staticClass: "left-centered", attrs: { span: 12 } }, [
            _c("img", {
              staticStyle: { width: "250px", height: "42px" },
              attrs: {
                src: require("../../../../assets/unifi-logo-new-with-text-green.svg")
              },
              on: { click: _vm.toHome }
            })
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "right-centered", attrs: { span: 12 } }, [
            _c("img", {
              staticStyle: { height: "50px" },
              attrs: { src: require("../../../../assets/menu-alt-new.svg") },
              on: {
                click: function($event) {
                  return _vm.$emit("spread")
                }
              }
            })
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db456512", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db456512","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/steps/stepsHeader.vue
// module id = null
// module chunks = 